import { createSlice } from '@reduxjs/toolkit';
import { Features, isFeatureEnabled } from '../../../featureToggles/features';
import { updatePaymentMethod } from './updatePaymentMethod.thunks';

export interface IUpdatePaymentMethodState {
  loading: boolean;
  error: boolean;
}
const initialState: IUpdatePaymentMethodState = {
  loading: false,
  error: false
};

const updatePaymentMethodSlice = createSlice({
  name: 'updatePaymentMethod',
  initialState,
  reducers: {},
  extraReducers: {
    [updatePaymentMethod?.pending.type]: (state: IUpdatePaymentMethodState): void => {
      if (isFeatureEnabled(Features.PlgExternal)) {
        state.loading = true;
        state.error = false;
      }
    },
    [updatePaymentMethod?.fulfilled.type]: (state: IUpdatePaymentMethodState): void => {
      if (isFeatureEnabled(Features.PlgExternal)) {
        state.loading = false;
        state.error = false;
      }
    },
    [updatePaymentMethod?.rejected.type]: (state: IUpdatePaymentMethodState): void => {
      if (isFeatureEnabled(Features.PlgExternal)) {
        state.loading = false;
        state.error = true;
      }
    }
  }
});

export default updatePaymentMethodSlice.reducer;